import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from '../layouts/AppShell';
import { RequireAuth } from '../components/auth/RequireAuth';
import ShippingAdjustPage from '../pages/ShippingAdjustPage';
import InventoryListPage from '../pages/InventoryListPage';
import InventoryDetailPage from '../pages/InventoryDetailPage';
import SupplierSharePage from '../pages/SupplierSharePage';
import SupplierLoginPage from '../pages/SupplierLoginPage';
import SupplierShareEditPage from '../pages/SupplierShareEditPage';
import NisugataMasterPage from '../pages/NisugataMasterPage';
import InboundSchedulePage from '../pages/InboundSchedulePage';
import CustomerInfoPage from '../pages/CustomerInfoPage';
import CustomerOrderHistoryPage from '../pages/CustomerOrderHistoryPage';
import SupplierManagementPage from '../pages/SupplierManagementPage';
import LoginPage from '../pages/LoginPage';
import UserManagementPage from '../pages/UserManagementPage';

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/supplier-login" element={<SupplierLoginPage />} />
      <Route path="/supplier-share-edit" element={<SupplierShareEditPage />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <AppShell>
              <Routes>
                <Route path="/" element={<Navigate to="/shipping" replace />} />
                <Route path="/shipping" element={<ShippingAdjustPage />} />
                <Route path="/inventory" element={<InventoryListPage />} />
                <Route path="/inventory/:productDisp" element={<InventoryDetailPage />} />
                <Route path="/supplier-share" element={<SupplierSharePage />} />
                <Route path="/inbound-schedule" element={<InboundSchedulePage />} />
                <Route path="/nisugata" element={<NisugataMasterPage />} />
                <Route path="/customer-order-history" element={<CustomerOrderHistoryPage />} />
                <Route path="/customer-info" element={<CustomerInfoPage />} />
                <Route path="/supplier-management" element={<SupplierManagementPage />} />
                <Route
                  path="/users"
                  element={
                    <RequireAuth adminOnly>
                      <UserManagementPage />
                    </RequireAuth>
                  }
                />
              </Routes>
            </AppShell>
          </RequireAuth>
        }
      />
    </Routes>
  );
};
